import { render, staticRenderFns } from "./RSSDviewContent.vue?vue&type=template&id=cd1121da&scoped=true&"
import script from "./RSSDviewContent.vue?vue&type=script&lang=js&"
export * from "./RSSDviewContent.vue?vue&type=script&lang=js&"
import style0 from "./RSSDviewContent.vue?vue&type=style&index=0&id=cd1121da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1121da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
